export default {
  title: "Internal Bank Accounts",
  subtitle: "Overview",
  path: "internal_bank_account_overview",
  paragraph: "The Internal accounts are accounts created by FacilitaPay inside our environment to be used to accumulate the payments you receive locally, for conversions and settlements. There is usually one of them for each local currency (cash-in) and separate accounts for foreign currencies (cash-in and cash-out). To check their IDs, look on the Bank Accounts page, on the portal.",
  request: {}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/InternalBankAccounts.js